"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _bwaCheckoutButtonRenderHandler = _interopRequireDefault(require("./bwa-checkout-button-render-handler"));
var _bwaQuickCheckoutRenderHandler = _interopRequireDefault(require("../bwa-quick-checkout/bwa-quick-checkout-render-handler"));
var _bwaEmbeddedCheckoutRenderHandler = _interopRequireDefault(require("../bwa-embedded-checkout/bwa-embedded-checkout-render-handler"));
var _constants = require("../../constants/constants");
var _utils = require("../../utils/utils");
var BwaCheckoutButton = exports["default"] = /*#__PURE__*/function () {
  function BwaCheckoutButton() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, BwaCheckoutButton);
    if (document.readyState === "complete" || document.readyState === "interactive") {
      this.initRenderHandler();
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        return _this.initRenderHandler();
      });
    }
  }
  return (0, _createClass2["default"])(BwaCheckoutButton, [{
    key: "initRenderHandler",
    value: function () {
      var _initRenderHandler = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var bwaCheckoutButtonRenderHandler, bwaQuickCheckoutRenderHandler, bwaEmbeddedCheckoutRenderHandler, otherCheckoutButtonSelectors;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              bwaCheckoutButtonRenderHandler = new _bwaCheckoutButtonRenderHandler["default"]();
              _context.next = 3;
              return bwaCheckoutButtonRenderHandler.executeHandler();
            case 3:
              bwaQuickCheckoutRenderHandler = new _bwaQuickCheckoutRenderHandler["default"]();
              _context.next = 6;
              return bwaQuickCheckoutRenderHandler.executeHandler();
            case 6:
              bwaEmbeddedCheckoutRenderHandler = new _bwaEmbeddedCheckoutRenderHandler["default"]();
              _context.next = 9;
              return bwaEmbeddedCheckoutRenderHandler.executeHandler();
            case 9:
              otherCheckoutButtonSelectors = window.bwaMerchantConfig.bwaCheckoutButton.otherCheckoutButtonSelectors || [];
              otherCheckoutButtonSelectors === null || otherCheckoutButtonSelectors === void 0 || otherCheckoutButtonSelectors.forEach(function (selector) {
                return (0, _utils.safeQuerySelectorAll)(selector).forEach(function (element) {
                  return element.addEventListener('click', function (e) {
                    window.dispatchEvent(new CustomEvent(_constants.EVENT_TYPE.CUSTOM.OTHER_CHECKOUT_BUTTON_SUBMIT));
                  });
                });
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function initRenderHandler() {
        return _initRenderHandler.apply(this, arguments);
      }
      return initRenderHandler;
    }()
  }]);
}();
//# sourceMappingURL=bwa-checkout-button.js.map
